<template>
  <div class="doc-line">
    <div class="theOrdName">
      <!-- {{doc}} -->
      <p>{{ doc.ivnum }}</p>
    </div>
    <div class="theOrdDate">
      <p>{{ formatDate(doc.ivdate) }}</p>
    </div>
    <div class="theOrdDueDate">
      <p>{{ formatDate(doc.paydate) }}</p>
    </div>
    <div v-if="$route.name === 'orders'" class="theOrdReference">
      <p>{{ doc.reference }}</p>
    </div>
    <div class="status theOrdStatus" :class="$route.name">
      <p>{{ doc?.Status?.statusname }}</p>
    </div>
    <div class="price theOrdPrice">
      <p>₪{{ formattedNumber(doc.totprice) }}</p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    doc: {
      type: Object,
    },
  },
  methods: {
    formatDate(senddate) {
      const formattedDate = moment(senddate).format("DD/MM/YY");
      if (formattedDate !== "Invalid date") {
        return formattedDate;
      } else return this.$t("filtersWidget.ordersAndInvoicesDateLabel");
    },
    formattedNumber(num) {
      if(num) return num.toLocaleString();
      else return 'חסר'
    },
  },
};
</script>

<style scoped lang="scss">
.doc-line {
  display: flex;
  gap: 10px;
  align-items: center;
  background-color: $primaryBackgroundColor;
  border-radius: 15px;
  padding: 15px;
  margin: 20px 0;
  position: relative;
  width: 100%;
  justify-content: space-between;

  div {
    min-width: 120px;
    flex: 1;
  }

  p {
    font-size: $mediumTextSize;
    color: $orderLineColor;
    font-weight: 400;
    line-height: 21.33px;
    text-align: right;
    width: fit-content;
  }

  &:hover {
    cursor: pointer;
  }
}

.status {
  p {
    display: inline;
    color: white;
    padding: 3px 10px;
    border-radius: 50px;
  }
}

.orders p {
  background-color: $ordersMainColor;
}

.invocies p {
  background-color: $invoicesAndReturns;
}

@media only screen and (max-width: 768px) {
  .doc-line {
    flex-direction: row;
    align-items: flex-start;

    div {
      width: 100%;
      padding: 0px 15px;
    }
  }
}
</style>
